import { render, staticRenderFns } from "./avance-revision-lista.vue?vue&type=template&id=9adde678&"
import script from "./avance-revision-lista.vue?vue&type=script&lang=js&"
export * from "./avance-revision-lista.vue?vue&type=script&lang=js&"
import style0 from "./avance-revision-lista.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports